import { CheckoutFieldsOrder, countries, Language } from "./Config";
// import moment from 'moment';
import moment from 'moment-timezone';

let BASE_URL = process.env.REACT_APP_BASE_URL


let helper = {
    ApiUrl: BASE_URL + '/api/tourist/',
    validExtensions: ['jpg', 'png', 'jpeg', 'avif'],
    baseUrl: BASE_URL,
    supplierUrl: process.env.REACT_APP_SUPPLIER_BASE_URL,
    S3Url: process.env.REACT_APP_AWS_URL,
    productImageDir: process.env.REACT_APP_S3_PRODUCT_IMAGE_DIRECTORY,
    profileImageDir: process.env.REACT_APP_S3_PROFILE_IMAGE_DIRECTORY,
    companyImageDir: process.env.REACT_APP_S3_COMPANY_IMAGE_DIRECTORY,
    locationImageDir: process.env.REACT_APP_S3_LOCATION_IMAGE_DIRECTORY,
    blogImageDir: process.env.REACT_APP_S3_BLOG_IMAGE_DIRECTORY,
    footerImageDir: process.env.REACT_APP_S3_FOOTER_IMAGE_DIRECTORY,
    mapboxAccessToken: process.env.REACT_APP_MAP_BOX_ACCESSTOKEN,
    bookingReceiptDirectory: process.env.REACT_APP_S3_BOOKING_RECEIPT_DIRECTORY,
    adminWhatsappNumber: process.env.REACT_APP_ADMIN_WHATSAPP_NUMBER,
    paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    maxLocalStorage: 5 * 1024 * 1024



}

export const phoneErrorMap = [
    "Invalid phone number",
    "Invalid country code",
    "Phone numbr is Too short",
    "Phone numbr is Too long",
    "Invalid phone number"
];

export function ApiHeaders(token) {
    let apiHeader = {};
    if (token != null) {
        apiHeader['Authorization'] = `Bearer ${token}`
    }
    apiHeader['Access-Control-Allow-Origin'] = '*'
    apiHeader['Accept'] = 'application/json'

    return apiHeader;
}

export const convertToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

export function generateSlug(str) {
    return str
        .toLowerCase()              // Convert to lowercase
        .trim()                      // Remove leading/trailing spaces
        .replace(/\s+/g, '-')        // Replace spaces with hyphens
        .replace(/[^\w-]+/g, '')     // Remove non-word characters (anything except letters, numbers, and hyphens)
        .replace(/--+/g, '-')        // Replace multiple hyphens with a single one
        .replace(/^-+|-+$/g, '');    // Remove leading/trailing hyphens
}

export function revertSlug(slug) {
    return slug
        .toLowerCase()                       // Ensure it's lowercase
        .split('-')                           // Split the slug by hyphens
        .map((word, index) => {
            // Capitalize the first letter of each word
            return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');                           // Join the words with spaces
}

export function convertToTitleCase(string) {
    string = string.toLowerCase().replace(/_/g, ' ');
    return string.replace(/\b\w/g, char => char.toUpperCase());
}

export function getLanguageName(code) {
    return Object.keys(Language).find(key => Language[key] === code) || null;
}

export function convertEpochToDate(timestamp) {


    let myDate = new Date(timestamp);
    let dateStr = myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate();
    return dateStr

}

function convertHoursToDaysAndHours(hours) {
    var days = Math.floor(hours / 24);
    var remainingHours = hours % 24;

    var result = '';
    if (days > 0) {
        result += days + ' day' + (days > 1 ? 's' : '');
    }
    if (remainingHours > 0) {
        result += (days > 0 ? ' and ' : '') + remainingHours + ' hour' + (remainingHours > 1 ? 's' : '');
    }

    return result;
}

// const calculateCutoffTime = (dateString, timeString, cutoffHours) => {
//     const dateTimeString = `${dateString} ${timeString}`;
//     const dateTime = moment(dateTimeString, "YYYY-MM-DD HH:mm");
//     const updatedDateTime = dateTime.subtract(cutoffHours, 'hours');

//     return updatedDateTime.format("DD MMMM YYYY [at] HH:mm");
// };
const calculateCutoffTime = (dateString, timeString, cutoffHours, timezone = 'UTC') => {
    const dateTimeString = `${dateString} ${timeString}`;

    const dateTime = moment.tz(dateTimeString, 'YYYY-MM-DD HH:mm', timezone);
    const updatedDateTime = dateTime.subtract(cutoffHours, 'hours');

    return updatedDateTime.utc().format('DD MMMM YYYY [at] HH:mm [UTC]');
};


export function generateCancellationPolicy(data, date, time, timezone) {
    data = JSON.parse(data);
    // console.log(date,'date....');


    var text = '';
    if (data) {
        if (data.policyType === 'ADVANCED') {
            // text = data.title + '\n\n';
            // text += 'Cancellation fees are calculated based on a list of penalty rules. Flexible, but complicated.\n';
            data.penaltyRules.forEach(function (rules) {
                var per = rules.percentage;
                text += "Cancellation fee of " + per + "% is charged if cancelled until " + calculateCutoffTime(date, time, rules.cutoffHours, timezone);
            });
        } else if (data.policyType === 'NON_REFUNDABLE') {
            // text = data.title + '\n\n';
            text += "Bookings are not refundable, all sales are final.";
        } else if (data.policyType === 'FULL_REFUND') {
            // text = data.title + '\n\n';
            text += "Bookings are fully refundable up to " + calculateCutoffTime(date, time, data.simpleCutoffHours, timezone);
        } else if (data.policyType === 'SIMPLE') {
            // text = data.title + '\n\n';
            // text += "Bookings are fully refundable until a specific number of hours before the event.\n";
            // text += "• Full refund if cancelled at least " + convertHoursToDaysAndHours(data.simpleCutoffHours) + " before the event";
            text += "Fully refundable until " + calculateCutoffTime(date, time, data.simpleCutoffHours, timezone);

        }
    }

    return text;
}

export function generateCancellationPolicyDateFormat(data, date, time, timeZone) {
    data = JSON.parse(data);

    var text = '';
    if (data) {
        if (data.policyType === 'ADVANCED') {
            // text = "Free Cancellation" + '\n\n';
            // text += 'Cancellation fees are calculated based on a list of penalty rules. Flexible, but complicated.\n';
            data.penaltyRules.forEach(function (rules) {
                var per = rules.percentage;
                // text += "Free Cancellation Until " + calculateCutoffTime(date, time, rules.cutoffHours);
                text += "Cancellation fee of " + per + "% is charged  Until " + calculateCutoffTime(date, time, rules.cutoffHours, timeZone);

            });
        } else if (data.policyType === 'NON_REFUNDABLE') {
            // text = data.title + '\n\n';
            text += "Bookings are not refundable, all sales are final.";
        } else if (data.policyType === 'FULL_REFUND') {
            // text = data.title + '\n\n';
            // text = "Free Cancellation" + '\n\n';
            text += "Free Cancellation Up to " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);
        } else if (data.policyType === 'SIMPLE') {
            // text = data.title + '\n\n';
            // text += "Bookings are fully refundable until a specific number of hours before the event.\n";
            // text += "• Full refund if cancelled at least " + convertHoursToDaysAndHours(data.simpleCutoffHours) + " before the event";
            text += "Fully refundable until " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);

        }
    }

    return text;
}

export function generateCancellationPolicyCheckout(data, date, time, timeZone) {
    data = JSON.parse(data);
    // console.log(date,'date....');


    var text = '';
    if (data) {
        if (data.policyType === 'ADVANCED') {
            // text = data.title + '\n\n';
            // text += 'Cancellation fees are calculated based on a list of penalty rules. Flexible, but complicated.\n';
            data.penaltyRules.forEach(function (rules) {
                var per = rules.percentage;
                text += "Until " + calculateCutoffTime(date, time, rules.cutoffHours, timeZone);
            });
        } else if (data.policyType === 'NON_REFUNDABLE') {
            // text = data.title + '\n\n';
            text += "Bookings are not refundable, all sales are final.";
        } else if (data.policyType === 'FULL_REFUND') {
            // text = data.title + '\n\n';
            text += "Up to " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);
        } else if (data.policyType === 'SIMPLE') {
            // text = data.title + '\n\n';
            // text += "Bookings are fully refundable until a specific number of hours before the event.\n";
            // text += "• Full refund if cancelled at least " + convertHoursToDaysAndHours(data.simpleCutoffHours) + " before the event";
            text += "Fully refundable until " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);

        }
    }

    return text;
}

const formatCountry2 = (country) => {

    return `<i class="fi fi-${country.iso_name} fi-rounded"></i> ${convertToTitleCase(country.label)}`;
};

export const CountrySelectoptions2 = countries.map((country) => ({
    id: country.code,
    text: formatCountry2({ label: country.name, iso_name: country.iso_name }),
    value: country.code,
}));

export const LanguageSelectoptions2 = Object.entries(Language).map((lan) => ({
    id: lan[1],
    text: lan[0],
    value: lan[1],
}));

export function sortByCustomOrder(data) {

    return data.slice().sort((a, b) => {
        let indexA = CheckoutFieldsOrder.indexOf(a.field);
        let indexB = CheckoutFieldsOrder.indexOf(b.field);

        // If field is not in CheckoutFieldsOrder, push it to the end
        indexA = indexA === -1 ? CheckoutFieldsOrder.length : indexA;
        indexB = indexB === -1 ? CheckoutFieldsOrder.length : indexB;

        return indexA - indexB;
    });
}

export function getCountrySelectedOpt(code) {
    let selectedCountryData = CountrySelectoptions2.filter((e) => e.id == code)
    if (selectedCountryData.length > 0) {
        return selectedCountryData[0]
    }
    return null
}

// export const checkDateStatus = (date) => {
//     const today = moment().startOf("day"); // Get today's date at midnight
//     const inputDate = moment(date, "YYYY-MM-DD").startOf("day"); // Parse input date

//     return inputDate.isSameOrBefore(today) ? "Completed" : "Awaiting";
// };

export const checkDateStatus = (date, time) => {
    const now = moment(); // Get current datetime
    const inputDateTime = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm"); // Parse input date with time

    return inputDateTime.isSameOrBefore(now) ? "Completed" : "Awaiting";
};

export const getCountryByCode = (code) => {
    if (code) {

        let countryIndex = countries.findIndex((e) => e.code == code)
        if (countryIndex != -1) {
            return countries[countryIndex]?.name ? convertToTitleCase(countries[countryIndex]?.name) : ''
        }

    }
    return "";

}

export function formatMbWayNumber(dialCode, mobileNumber) {
    // Remove the '+' from the mobile number
    let cleanedNumber = mobileNumber.replace(/^\+/, '');

    // Remove the dial code if it exists at the start of the number
    if (cleanedNumber.startsWith(dialCode)) {
        cleanedNumber = cleanedNumber.slice(dialCode.length);
    }

    return `${dialCode}#${cleanedNumber}`;
}

export function getPaymentTypeText(type) {
    let method = ""
    if (type == "card") {
        method = "Stripe (Card)"
    }
    if (type == "mb_way") {
        method = "MB Way"
    }
    if (type == "cash") {
        method = "Cash"
    }

    if (type == "paypalint" || type == "paypal") {
        method = "Paypal"
    }
    if (type == "multibanco") {
        method = "Multibanco"
    }
    return method;

}

export function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}


export function getSlugNameByLang(lang) {
    switch (lang) {
        case "English":
            return 'slug'
            break;
        case "French":
            return 'fr_slug'
            break;
        case "German":
            return 'de_slug'
            break;
        case "Italian":
            return 'it_slug'
            break;
        case "Portuguese":
            return 'pt_slug'
            break;
        case "Spanish":
            return 'es_slug'
            break;
        default:
            return 'slug'
    }

}

export function getLinkNameByLang(lang) {
    switch (lang) {
        case "English":
            return 'link'
            break;
        case "French":
            return 'fr_link'
            break;
        case "German":
            return 'de_link'
            break;
        case "Italian":
            return 'it_link'
            break;
        case "Portuguese":
            return 'pt_link'
            break;
        case "Spanish":
            return 'es_link'
            break;
        default:
            return 'link'
    }

}
export function getTitleNameByLang(lang) {
    switch (lang) {
        case "English":
            return 'title'
            break;
        case "French":
            return 'fr_title'
            break;
        case "German":
            return 'de_title'
            break;
        case "Italian":
            return 'it_title'
            break;
        case "Portuguese":
            return 'pt_title'
            break;
        case "Spanish":
            return 'es_title'
            break;
        default:
            return 'title'
    }
}

export function getNameByLang(lang) {
    switch (lang) {
        case "English":
            return 'name'
            break;
        case "French":
            return 'fr_name'
            break;
        case "German":
            return 'de_name'
            break;
        case "Italian":
            return 'it_name'
            break;
        case "Portuguese":
            return 'pt_name'
            break;
        case "Spanish":
            return 'es_name'
            break;
        default:
            return 'name'
    }
}

export function getSlugByLang(lang) {
    switch (lang) {
        case "English":
            return 'en'
            break;
        case "French":
            return 'fr'
            break;
        case "German":
            return 'de'
            break;
        case "Italian":
            return 'it'
            break;
        case "Portuguese":
            return 'pt'
            break;
        case "Spanish":
            return 'es'
            break;
        case "Other":
            return 'othr'
            break;
        default:
            return 'en'
    }

}

export function getLangBySlug(slug) {
    switch (slug) {
        case 'en':
            return 'English';
        case '':
            return 'English';
        case 'fr':
            return 'French';
        case 'de':
            return 'German';
        case 'it':
            return 'Italian';
        case 'pt':
            return 'Portuguese';
        case 'es':
            return 'Spanish';
        case 'othr':
            return 'Other';
        default:
            return 'English';
    }
}

export function getSlugNameByTitleField(field) {
    switch (field) {
        case "title":
            return 'slug'
            break;
        case "fr_title":
            return 'fr_slug'
            break;
        case "de_title":
            return 'de_slug'
            break;
        case "it_title":
            return 'it_slug'
            break;
        case "pt_title":
            return 'pt_slug'
            break;
        case "es_title":
            return 'es_slug'
            break;
        default:
            return 'slug'
    }

}
export function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function getProductImageUrl(img) {
    if (!img) return null;

    // Check if the image is already a full URL
    const isFullUrl = /^https?:\/\//i.test(img);

    if (isFullUrl) {
        return img;
    }

    // If only image name, construct the URL using helper values
    return `${helper.S3Url}/${helper.productImageDir}/${img}`;
}
// export function formatMeetingLocation(locationArray) {
//     locationArray = !Array.isArray(locationArray) ? JSON.parse(locationArray) : locationArray
//     if (!Array.isArray(locationArray) || locationArray.length === 0) {
//         return "";
//     }

//     if (locationArray.length > 3) {
//         // return `${locationArray[2]}, ${locationArray[1]}`;
//         return `${locationArray[locationArray.length - 1]}, ${locationArray[1]}`;
//     } else if (locationArray.length === 1) {
//         return locationArray[0];
//     } else {
//         return `${locationArray[1]}, ${locationArray[0]}`;
//     }
// }
export function formatMeetingLocation(locationArray) {

    if (!Array.isArray(locationArray)) {
        try {
            locationArray = JSON.parse(locationArray);
        } catch (e) {
            return "";
        }
    }

    if (!Array.isArray(locationArray) || locationArray.length === 0) {
        return "";
    }

    // Deduplicate while preserving order
    const seen = new Set();
    const uniqueLocations = locationArray.filter(item => {
        if (seen.has(item)) return false;
        seen.add(item);
        return true;
    });

    const len = uniqueLocations.length;

    if (len > 3) {
        return `${uniqueLocations[len - 1]}, ${uniqueLocations[1]}`;
    } else if (len === 1) {
        return uniqueLocations[0];
    } else {
        // return `${uniqueLocations[1]}, ${uniqueLocations[0]}`;
        return `${uniqueLocations[len - 1]}, ${uniqueLocations[1]}`;
    }
}

export function getByteLength(str) {
    // Returns the UTF-8 byte length of a string
    return new Blob([str]).size;
}

export function getCookie(name) {
    let cookieArr = document.cookie.split("; ");
    for (let cookie of cookieArr) {
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}




export default helper